import { GiCheckMark } from 'react-icons/gi'

import { Container } from './style'

export function CheckInput ({ handleClickCheck, inputValueToChange, setOthersClick }) {
    return(
        <Container 
            onClick={() => { 
                handleClickCheck(!inputValueToChange)
                if(setOthersClick) 
                    setOthersClick()
            }}
        >
            {
                inputValueToChange ?
                    <GiCheckMark />
                : <></>
            }
        </Container>
    )
}